import { type StateCreator } from 'zustand';

export type CanvasTokenNodeGroup = {
  id: string;
  x?: number;
  y?: number;
  width?: number;
  height?: number;
  zIndex?: number;
};

type CanvasTokenNodeBase = {
  group: CanvasTokenNodeGroup;
  updatedAt?: string;
};

export type CanvasTokenImageNode = CanvasTokenNodeBase & {
  type: 'image';
  fileName: string;
  media: { image: string; original: string };
  runId?: string;
};

export type CanvasTokenVideoNode = CanvasTokenNodeBase & {
  type: 'video';
  fileName: string;
  media: { image: string; original: string };
  runId?: string;
};

export type CanvasTokenTextNode = CanvasTokenNodeBase & {
  type: 'text';
  fileName: '';
  textNode: {
    text: string;
    fontSize: number;
    fontFamily: string;
    fontColor: string;
    textAlign: string;
    fontVariant: string;
    fontSource: 'builtIn' | 'file';
    fontFileUrl?: string;
    fontMetadataUrl?: string;
    lineHeight: number;
    letterSpacing: number;
  };
};

export type CanvasTokenNode = CanvasTokenImageNode | CanvasTokenVideoNode | CanvasTokenTextNode;

export type CanvasTokenNodeSlice = {
  nodes: Record<string, CanvasTokenNode>;
  setNodes: (nodes: Record<string, CanvasTokenNode>) => void;
};

export type CreateCanvasTokenNodeSlice = () => StateCreator<CanvasTokenNodeSlice, [], [], CanvasTokenNodeSlice>;

export const createCanvasTokenNodeSlice: CreateCanvasTokenNodeSlice = () => (set) => ({
  nodes: {},
  setNodes: (nodes) => {
    set({ nodes });
  },
});
